import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { PermissionService } from '@core/auth/services/permission.service'
import { ContentUnitCtaButtonComponent } from '@features/content-unit/components/content-unit-cta-btn/content-unit-cta-btn.component'
import { ContentState, setupContentStateRouteListener } from '@core/utils/route-utils'
import { ContentUnitDisplayComponent } from '@features/content-unit/components/content-unit-display/content-unit-display.component'
import { ContentUnitManagerService } from '@features/content-unit/services/content-unit-manager.service'

export type ContentUnitContentState = 'none' | 'create' | 'view' | 'edit' | 'duplicate'

@Component({
  selector: 'albert-content-unit',
  standalone: true,
  imports: [
    ContentUnitCtaButtonComponent,
    ContentUnitDisplayComponent
  ],
  templateUrl: './content-unit.component.html',
  styleUrl: './content-unit.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ContentUnitManagerService]
})
export class ContentUnitComponent implements OnInit {
  public readonly manager = inject(ContentUnitManagerService)
  public readonly contentState = signal<ContentState>('none')
  protected readonly router = inject(Router)
  protected readonly permissionService = inject(PermissionService)
  private readonly route = inject(ActivatedRoute)
  private readonly destroyRef = inject(DestroyRef)

  public ngOnInit(): void {
    setupContentStateRouteListener(this.route, this.destroyRef, this.manager.contentState, this.contentState)
  }

}
